<template>
  <div>
    <div class="msg-main">
      <div class="msg-title">
        <h1>客户案例</h1>
        <a><img src="../../../assets/images/right-arrow-gray.png"></a>
      </div>
      <div class="msg-content">
        <div>
          <img src="../../../assets/images/kindee_logo.png">
          <hr>
          <span>金蝶</span>
        </div>
        <div class="logo-gap">
          <img src="../../../assets/images/nanfang_logo.png">
          <hr>
          <span>中国南方电网</span>
        </div>
        <div class="logo-gap">
          <img src="../../../assets/images/huawei_logo.png">
          <hr>
          <span>华为</span>
        </div>
        <div>
          <img src="../../../assets/images/cmb-logo.png">
          <hr>
          <span>招商银行</span>
        </div>
        <div class="logo-gap">
          <img src="../../../assets/images/jiuxin_logo.png">
          <hr>
          <span>九芯净水</span>
        </div>
        <div class="logo-gap">
          <img src="../../../assets/images/zhongxin_logo.png">
          <hr>
          <span>中信银行</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerExample'
}
</script>

<style scoped lang="stylus">
  .msg-main
    width: 84.4%;
    max-width: 1200px;
    margin: 0 auto
    padding-bottom: 57px
    .msg-title
      margin-left: 71px;
      h1
        padding-top: 87px
        font-weight: 400
        font-size: 32px
        display: inline-block
        margin: 0
      a
        display: inline-block
        vertical-align: bottom
        img
          width: 37px
          margin-left: 30px
          vertical-align: bottom
    .msg-content
      margin: 90px 0 0 71px;
      display: inline-block
      vertical-align: top
      div
        width: 260px
        text-align: center
        display: inline-block
        font-size: 20px
        img
          width: 100%
        hr
          width: 190px
          margin-top: 25px
          border: 1.5px solid #e5e5e5
        span
          display: inline-block
          margin-top: 20px
          border: 6px solid #e5e5e5
          padding: 0 13px
      .logo-gap
        margin-left: 125px
      div:nth-child(3n+4)
        margin-top: 115px
</style>



// WEBPACK FOOTER //
// src/pages/home/components/CustomerExample.vue